import { Component, Input } from '@angular/core';
import { Encoding } from '@mode-vegas/vegas';
import { SelectedChartService } from '@mode/charts/contract';
import { ChartTypes, FlamingoTypes } from '@mode/shared/contract-common';
import { FieldDropHandlerService } from '../cartesian-builder-common/field-drop-handler.service';
import { GroupedDropHandlerService } from './grouped-drop-handler.service';

@Component({
  selector: 'mode-grouped-builder',
  templateUrl: './grouped-builder.component.html',
  providers: [{ provide: FieldDropHandlerService, useClass: GroupedDropHandlerService }],
})
export class GroupedBuilderComponent {
  @Input({ required: true }) encoding!: Encoding;
  @Input() observables: any;
  @Input({ required: true }) chartService!: SelectedChartService;
  @Input({ required: true }) model!: FlamingoTypes.ModeModel;
  @Input() isExploring = false;
  @Input({ required: true }) chartType!: ChartTypes.ChartType;
}
